export default __webpack_public_path__ + "static/media/slide-paga-comercio.ab659907.png";